module.exports = __webpack_public_path__ + "static/media/elvan-02.b8fad7f0.jpg";